<template>
  <div class="loginApp">
    <div class="loginApp-nav clearfix container-fluid">
      <div class="wraper">
        <div class="logo pull-left">
          <img src="https://easyreadfs.nosdn.127.net/qwb.015aedcd6fd844f2b2e7073bcef0d163.jpg" alt="网易文学" />

        </div>
        <div class="nav-bar pull-right">
          <a @click="tweenScroll(551)" class="nav-item">我们的优势</a>
          <a @click="tweenScroll(1060)" class="nav-item">合作模式</a>
          <a @click="tweenScroll(1541)" class="nav-item">成功案例</a>
        </div>
      </div>
    </div>
    <div class="main">
      <div class="sec-01">
        <div class="wraper">
          <a :href="concat.indexPage" class="goReg" target="_blank"></a>
        </div>
      </div>
      <div class="sec-02"></div>
      <div class="sec-03"></div>
      <div class="sec-04"></div>
      <div class="sec-link">
        <div class="wraper clearfix">
          <div class="contact pull-left">
            <h4>联系我们</h4>
            <div class="sep"></div>
            <ul class="clearfix">
              <li>QQ：{{concat.qq}}</li>
              <li>微信：{{concat.wx}}</li>
              <li>地址：浙江省杭州市滨江区网商路599号网易大厦</li>
            </ul>
          </div>
          <div class="links pull-right">
            <h4>友情链接</h4>
            <div class="sep"></div>
            <ul class="clearfix">
                <li v-for="item in address"><a :href="item.url" target="_blank">{{item.name}}</a></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <div class="g-ftw">
        <div class="g-ft clearfix">
          <div class="m-foot">
            <p class="link">
              <a href="http://www.163.com" target="_blank">网易首页</a><span class="sep">|</span>
              <a href="http://gb.corp.163.com/gb/about/overview.html" target="_blank">公司简介</a><span class="sep">|</span>
              <a href="http://help.163.com/" target="_blank">客户服务</a><span class="sep">|</span>
              <a href="http://corp.163.com/gb/legal/legal.html" target="_blank">相关法律</a><span class="sep">|</span>
              <a href="http://sitemap.163.com/" target="_blank">网站导航</a><span class="sep">|</span>
              <a href="http://fankui.163.com/ft/comment.fb?pid=11001" target="_blank">意见反馈</a><span class="sep">|</span>
              <a href="http://yuedu.163.com/help" target="_blank">帮助中心</a><span class="sep">|</span>
              <a href="http://open.yuedu.163.com/" target="_blank">作者中心</a>
            </p>
          </div>
          <div class="m-right">
            <p>网易公司版权所有&#169;1997-2019</p>
          </div>
          <a class='m-gongye' href="http://beian.miit.gov.cn/">工业和信息化部备案管理系统网站</a>
        </div>
      </div>
    </div>
    <div class="float-qr">
      <img :src="concat.qrcode" />
      <p>扫一扫联系我们</p>
    </div>
  </div>
</template>
<script>
import getConfig from './config'
export default {
    data () {
        return {
            address: [{
                'name': '网易云阅读',
                'url': 'https://yuedu.163.com'
            }, {
                'name': '网易漫画',
                'url': 'https://manhua.163.com'
            }, {
                'name': '网易蜗牛读书',
                'url': 'https://du.163.com'
            }, {
                'name': '国风中文网',
                'url': 'https://guofeng.yuedu.163.com/'
            }, {
                'name': '采薇书院',
                'url': 'https://caiwei.yuedu.163.com/'
            }, {
                'name': '网易LOFTER',
                'url': 'http://www.lofter.com/'
            }, {
                'name': '网易游戏',
                'url': 'http://game.163.com/'
            }, {
                'name': '易信',
                'url': 'http://yixin.im/'
            }, {
                'name': '网易云音乐',
                'url': 'http://music.163.com'
            },
            {
                'name': '网易云课堂',
                'url': 'http://study.163.com'
            },
            {
                'name': '网易新闻',
                'url': 'http://news.163.com/'
            },
            {
                'name': '网易企业邮箱',
                'url': 'https://qiye.163.com/'
            }
            ],
            concat: {}
        }
    },
    mounted () {
        getConfig().then(res => {
            this.concat = res.login
        })
    },
    methods: {
        tweenScroll (dist) {
            let doc = document.body.scrollTop ? document.body : document.documentElement
            let scrollTop = doc.scrollTop

            let step = () => {
                scrollTop = scrollTop + (dist - scrollTop) / 4
                if (Math.abs(scrollTop - dist) < 1) {
                    return
                }
                document.body.scrollTop = scrollTop
                document.documentElement.scrollTop = scrollTop
                window.requestAnimationFrame(step)
            }
            step()
        }
    }
}
</script>
<style lang="scss">
  .loginApp {
    font-family: Helvetica Neue For Number, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, PingFang SC, Hiragino Sans GB, Microsoft YaHei, Helvetica Neue, Helvetica, Arial, sans-serif;
    font-size: 12px;

    a {
      text-decoration: none;
      cursor: pointer;
    }

    li {
        list-style: none;
    }
    ul,p{
        margin: 0;
        padding: 0;
    }

    .m-gongye {
      color: red;
      display: block;
      margin: 15px auto 0;
      font-size: 18px;
      text-align: center;
    }

    .loginApp-nav {
      position: fixed;
      top: 0;
      height: 64px;
      width: 100%;
      background-color: #fcfcfc;
      z-index: 1000;

      .wraper {
        max-width: 1240px;
        margin: 0 auto;
      }

      .logo {
        margin-top: 16px;

        img {
          width: 285px;
        }
      }
    }

    .brand {
      display: none;
      margin-left: 10px;
      line-height: 64px;
      font-size: 20px;
      font-weight: bold;
    }

    .register {
      line-height: 64px;

      .anchor {
        padding: 7px 15px;
        font-size: 14px;
        color: #c44735;
        border: #c44735 solid 1px;
        border-radius: 5px;
      }
    }

    .nav-bar {
      margin-right: 76px;
      line-height: 64px;

      .nav-item {
        display: inline-block;
        font-size: 16px;
        color: #3a3a3a;
        padding-left: 27px;

        &:after {
          content: "|";
          padding-left: 27px;
          color: #efefef;
        }

        &:last-child:after {
          display: none;
        }
      }
    }

    .main {
      .sec-01 {
        position: relative;
        margin-top: 64px;
        height: 548px;
        background: url(https://easyreadfs.nosdn.127.net/CKUL3WB01cBEZtG7FuJGVg==/8796093024914748664) center top no-repeat;
        background-size: auto 548px;

        .wraper {
          max-width: 1240px;
          height: 548px;
          margin: 0 auto;
          position: relative;
        }

        .goReg {
          width: 210px;
          height: 60px;
          position: absolute;
          left: 0;
          top: 68.6%;
          background: url(https://easyreadfs.nosdn.127.net/web/trunk/1503468981457/2xb1.jpg) 0 0 no-repeat;
          background-size: 100% 100%;
        }
      }

      .sec-02 {
        height: 500px;
        background: url(https://easyreadfs.nosdn.127.net/defination/file1552282787594.52dd6e059717020b736be903c6f76c4c.png) center top no-repeat;
        background-size: auto 500px;
      }

      .sec-03 {
        height: 490px;
        background: url(https://easyreadfs.nosdn.127.net/defination/file1545103132450.c3a070e5ad0dc4f353f0588baba9cc8e.png) center top no-repeat;
        background-size: auto 490px;
      }

      .sec-04 {
        height: 877px;
        background: url(https://easyreadfs.nosdn.127.net/defination/file1552282787647.a5811666423d19742c49971fde0fae58.png) center top no-repeat;
        background-size: auto 877px;
      }

      .sec-link {

        background-color: #434343;

        .sep {
          width: 40px;
          height: 2px;
          background-color: #717171;
          margin: 15px 0;
        }

        h4 {
          font-size: 18px;
          color: #717171;
        }

        li {
          color: #9d9d9d;
          font-size: 12px;
          line-height: 25px;
        }

        .wraper {
          max-width: 1240px;
          margin: 0 auto;
          padding: 48px 0;
          position: relative;

          .contact {}

          .links {
            width: 735px;

            li {
              float: left;
              width: 80px;
              margin-right: 65px;

              a {
                color: #9d9d9d;
                font-size: 12px;
                line-height: 25px;
                text-decoration: none;
              }
            }
          }
        }
      }
    }

    .login {
      padding-top: 25px;
      padding-bottom: 25px;
      box-sizing: content-box;
    }

    .login-wrapper {
      width: 1000px;
    }

    .float-qr {
      position: fixed;
      top: 438px;
      right: 28px;
      width: 120px;
      height: 140px;
      box-sizing: border-box;
      padding: 18px 18px 0 18px;
      background-color: #fff;
      box-shadow: 0 0 10px #999;
      border-radius: 10px;

      img {
        width: 80px;
        height: 80px;
      }

      p {
        margin: 10px 0 10px;
      }
    }

    .g-ftw {
      position: relative;
      background-color: #282828;
    }

    .g-ft {
      width: 980px;
      margin: 0 auto;
      padding: 40px 0 50px;
    }

    .m-foot {
      line-height: 17px;
    }

    .m-foot p {
      white-space: nowrap;
      text-align: center;
    }

    .m-foot .link a {
      color: #646464;
    }

    .m-foot .sep {
      margin: 0 6px;
      color: #646464;
    }

    .m-right {
      clear: both;
      padding: 10px 0 0 0;
    }

    .m-right p {
      text-align: center;
      color: #646464;
    }
  }

  .pull-right {
    float: right;
  }

  .pull-left {
    float: left;
  }

  .clearfix::after {
    display: block;
    content: '';
    clear: both;
  }

</style>



// WEBPACK FOOTER //
// src/pages/index/app.vue